import moment from "moment";
import { BAD_KEY_INPUTS } from "./constants";

export const formatBirthdateForUI = date => {
  return moment(date).format("MMMM Do YYYY");
};

export const disarmNonNums = (e, setSt, errorMessage, clearMessage) => {
  if (!BAD_KEY_INPUTS.includes(e.keyCode)) {
    setSt(errorMessage);
    e.preventDefault();
    return;
  }
  setSt(clearMessage);
};
